const Icons = {
  BOOKINGS: 'book-open',
  CONTACT_TRACING: 'clipboard',
  LOYALTY: 'star',
  ORDERS: 'package',
  PRICING: 'list',
};

export default Icons;
